import { CoreBase } from './core-base';

export class CoreLongBase extends CoreBase<number> {

}
